'use client'

import { sendGTMEvent } from '@next/third-parties/google'

/**
 * GTM 事件上报
 */
const reportGTMEvent = (data: object, clear: boolean = true, dataLayerName?: string) => {
  if (!process.env.NEXT_PUBLIC_GA_ID) {
    return
  }

  if (clear) {
    window.dataLayer?.push({ ecommerce: null })
  }

  sendGTMEvent(data, dataLayerName)
}

export default reportGTMEvent
